import { Space } from 'antd';
import styled from 'styled-components';

export const StyledToolbar = styled(Space)`
  padding: 0 ${({ theme: { token } }) => token.paddingLG}px;
  color: ${({ theme: { token } }) => token.previewOperationColor};
  font-size: ${({ theme: { token } }) => token.imagePreviewToolbarFontSize}px;
  background-color: ${({ theme: { token } }) => token.previewOperationColorBg};
  border-radius: 100px;

  .anticon {
    padding: 0 ${({ theme: { token } }) => token.paddingSM}px;
  }

  .anticon,
  .trash-icon {
    color: ${({ theme: { token } }) => token.previewOperationColor};
  }

  .anticon:disabled,
  .trash-icon:disabled {
    color: ${({ theme: { token } }) => token.previewOperationColorDisabled};
  }

  .anticon:hover:not([disabled]),
  .trash-icon:hover:not(.cursor-not-allowed) {
    opacity: 0.3;
    cursor: pointer;
  }

  .cursor-not-allowed {
    cursor: not-allowed;
  }
`;
